import { SURVEY_DATA, SURVEY_DATA_ERROR } from "../actions/types";

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SURVEY_DATA:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SURVEY_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
